import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { OcrProcess } from "./OcrProcessDisplay";
import OcrProcessLineItem from "./OcrProcessLineItem";

interface OcrProcessTableProps {
  process: OcrProcess;
}

export default class OcrProcessTable extends React.Component<OcrProcessTableProps> {
  statusToClass(status: number) {
    // Is this unused?
    if (status === 0) {
      return "danger";
    }
    if (status === 1) {
      return "warning";
    }
    return "info";
  }

  render() {
    if (
      Array.isArray(this.props.process.lineItems) &&
      this.props.process.lineItems.length > 0
    ) {
      return (
        <Row>
          <Col>
            <div className="table-responsive">
              <table className="table with-status table-sm table-hover middle">
                <thead>
                  <tr>
                    <th scope="col">Status</th>
                    <th scope="col">B-Nr.</th>
                    <th scope="col">Kostenart</th>
                    <th scope="col nowrap">B-Datum</th>
                    <th scope="col nowrap150">Leistungserbringer</th>
                    <th scope="col">R-Betrag</th>
                    <th scope="col">R-Datum</th>
                    <th scope="col">R-Nr.</th>
                    <th scope="col">
                      Leistungen
                      <br />
                      PKV/PPV
                    </th>
                    <th scope="col">
                      Leistung
                      <br />
                      Beihilfe
                    </th>
                    <th scope="col">Eigenanteil</th>
                    <th scope="col">Bezahlt am</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.process.lineItems &&
                    this.props.process.lineItems.map((x, idx) => (
                      <OcrProcessLineItem
                        item={x}
                        key={`le-${this.props.process.processNumber}-${idx}`}
                      />
                    ))}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      );
    }
    return "";
  }
}
